import SteinStore from "stein-js-client";

export default class SteinClient
{
    private static instance: SteinClient;
    public steinStore: any;
    private readonly _url: string;

    private constructor()
    {
        this._url = "https://api.steinhq.com/v1/storages/5f79e7405d3cdc44fcd7d56f";
        this.steinStore = new SteinStore(this._url);
    }

    public static getInstance(): SteinClient
    {
        if(!SteinClient.instance){
            SteinClient.instance = new SteinClient();
        }

        return SteinClient.instance;
    }
}
